import getExtensibilityState from './getExtensibilityState';

export default function isExtensibilityContextInitialized(): boolean {
    return getExtensibilityState().EnabledAddinCommands.isInitialized;
}
